// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"864e84d6","453":"abd36b29","455":"49d1df80"}[chunkId] + ".chunk.js";
};